import { store } from '../../../../resources/frontend/js/store';

/**
 * Check if all conditions match
 * @param {object} conditions
 */
export const isMatch = conditions => {
    return matchQuestionAnswers(conditions.questions) &&
        matchFormSteps(conditions.form_steps) &&
        matchURLParameters(conditions.url_parameters) &&
        matchOptions(conditions.options);
};

/**
 * Check if the question answers match the conditions
 * @param {array} questionConditions
 * @return {boolean}
 */
export const matchQuestionAnswers = questionConditions => {
    const questions = {};

    questionConditions.forEach(question => {
        const key = question.split('_')[0];
        const value = question.split(/_(.*)/s)[1];

        if (!questions[key]) questions[key] = [];

        questions[key].push(value);
    });

    const matchedQuestionConditions = Object.entries(questions).filter(([key, answers]) => {
        if (!store.getters['quiz/getAnswer'](key)) return false;

        let match = false;
        if (store.getters['quiz/getAnswer'](key).startsWith('array:')) {
            const answersArray = store.getters['quiz/getAnswer'](key).split(':')[1].split(',');
            answersArray.forEach(answer => {
                if (answers.includes(answer)) {
                    match = true;
                }
            });
        } else {
            answers.forEach(answer => {
                if (store.getters['quiz/getAnswer'](key) === answer) {
                    match = true;
                }
            });
        }

        return match;
    });

    return matchedQuestionConditions.length === Object.values(questions).length;
};

/**
 * Check if the form steps match the conditions
 * @param formSteps
 * @return {boolean}
 */
export const matchFormSteps = formSteps => {
    if (formSteps.length > 0) {
        const formStep = store.state.form.attributes.step;

        for (const step of formSteps) {
            if (step === formStep) {
                return true;
            }
        }

        return false;
    }

    return true;
};

/**
 * Check if the URL parameters match the conditions
 * @param parameters
 * @return {boolean}
 */
export const matchURLParameters = parameters => {
    // Parameters are formatted in an array like this: parameter=value
    // We need to check if the parameter is present in the URL and if the value matches
    const queryString = window.location.search;
    const urlParameters = new URLSearchParams(queryString);

    for (const parameter of parameters) {
        const key = parameter.parameter.split('=')[0];
        const value = parameter.parameter.split('=')[1];

        if (urlParameters.has(key)) {
            if (value) {
                if (urlParameters.get(key) !== value) {
                    return false;
                }
            }
        } else {
            return false;
        }
    }

    return true;
};

/**
 * Check if the options match the conditions
 * @param options
 * @return {boolean}
 */
export const matchOptions = options => {
    let match = true;

    options.forEach(option => {
        switch (option.key) {
        case 'dealership':
            if (option.value && !store.state.page.variables.dealership) {
                match = false;
            }
            break;
        case 'SMS verification':
            if (option.value && !store.state.page.variables.smsVerification) {
                match = false;
            }
            break;
        }
    });

    return match;
};

export const getTextWithConditions = text => {
    if (!text.useConditionalTexts) return text.text || text;

    let match = false;
    let value;

    for (const conditionalText of text.conditionalTexts) {
        if (isMatch(conditionalText.value.conditionals)) {
            value = conditionalText.value.text;
            match = true;
            break;
        }
    }

    if (!match) {
        value = text.text;
    }

    return value;
}
